import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { secondaryCategoryReportConfig } from '@webapp/modules/reports/config/reportConfigs'

const ReportAggregateViewChunk = lazy(() =>
  import('@webapp/modules/reports/feature-sets/ReportAggregateView').then(
    ({ ReportAggregateView }) => ({
      default: ReportAggregateView,
    })
  )
)

export const OrdersBySecondaryCategoryReportPage = () => {
  const intl = useProcurifyIntl()
  const pageTitle = intl.formatMessage(secondaryCategoryReportConfig.titleKey)

  return (
    <Page
      pageTitle={pageTitle}
      breadcrumbs={[{ name: pageTitle, escapeCaseFormatting: true }]}
    >
      <ReportAggregateViewChunk reportConfig={secondaryCategoryReportConfig} />
    </Page>
  )
}
